module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("推荐官管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search search-compact",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 78,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "老师ID/姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.referrerKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "referrerKeyword", $$v)
      },
      expression: "queryParam.referrerKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "FM",
      "label-width": 30
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.fmId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "fmId", _vm._n($$v))
      },
      expression: "queryParam.fmId"
    }
  }, _vm._l((_vm.fmList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "HR负责人",
      "label-width": 70
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hrName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hrName", $$v)
      },
      expression: "queryParam.hrName"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "状态",
      "label-width": 44
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("招聘试用期")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("招聘转正")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("招聘停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "年月",
      "label-width": 44
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "选择月份",
      "format": "yyyy-MM",
      "clearable": ""
    },
    on: {
      "on-change": _vm.yearMonthChange
    },
    model: {
      value: (_vm.queryParam.yearMonth),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "yearMonth", $$v)
      },
      expression: "queryParam.yearMonth"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.openAddModal
    }
  }, [_vm._v("添加推荐官")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "person-add"
    },
    on: {
      "click": _vm.openBatchHrModal
    }
  }, [_vm._v("分配HR负责人")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-calendar"
    },
    on: {
      "click": _vm.openBackfillModal
    }
  }, [_vm._v("生成历史汇总")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rank-panel"
  }, [_c('div', {
    staticClass: "rank-title"
  }, [_vm._v("奖励排行榜（" + _vm._s(_vm.queryParam.yearMonth || '本月') + "）")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.rankColumns,
      "data": _vm.rankList,
      "loading": _vm.rankLoading,
      "size": "small",
      "border": ""
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "1050",
      "title": "添加推荐官"
    },
    model: {
      value: (_vm.showAddModal),
      callback: function($$v) {
        _vm.showAddModal = $$v
      },
      expression: "showAddModal"
    }
  }, [_c('Form', {
    ref: "addForm",
    attrs: {
      "label-width": 100,
      "model": _vm.addParam,
      "rules": _vm.addRules
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "推荐官ID",
      "prop": "referrerId"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "min": 1,
      "precision": 0,
      "placeholder": "请输入推荐官老师ID"
    },
    on: {
      "on-change": _vm.onReferrerIdChange,
      "on-blur": _vm.onReferrerIdBlur
    },
    model: {
      value: (_vm.addParam.referrerId),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "referrerId", $$v)
      },
      expression: "addParam.referrerId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "推荐官姓名"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "留空则自动取老师姓名"
    },
    model: {
      value: (_vm.addParam.referrerName),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "referrerName", $$v)
      },
      expression: "addParam.referrerName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "FM"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择FM",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.addParam.fmId),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "fmId", _vm._n($$v))
      },
      expression: "addParam.fmId"
    }
  }, _vm._l((_vm.fmList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "HR负责人"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择HR负责人",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.addParam.hrName),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "hrName", $$v)
      },
      expression: "addParam.hrName"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "加入日期"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "请手动选择（默认空）",
      "format": "yyyy-MM-dd",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onAddJoinDateChange
    },
    model: {
      value: (_vm.addParam.joinDate),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "joinDate", $$v)
      },
      expression: "addParam.joinDate"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "选择状态",
      "transfer": ""
    },
    model: {
      value: (_vm.addParam.status),
      callback: function($$v) {
        _vm.$set(_vm.addParam, "status", $$v)
      },
      expression: "addParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("招聘试用期")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("招聘转正")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("招聘停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showAddModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "推荐官详情"
    },
    model: {
      value: (_vm.showDetailModal),
      callback: function($$v) {
        _vm.showDetailModal = $$v
      },
      expression: "showDetailModal"
    }
  }, [(_vm.detailData) ? _c('div', [_c('Row', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("推荐官ID：")]), _vm._v(_vm._s(_vm.detailData.referrerId) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.detailData.referrerName) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("状态：")]), _vm._v(_vm._s(_vm.getStatusText(_vm.detailData.status)) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("FM：")]), _vm._v(_vm._s(_vm.detailData.fmName || '-') + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("HR负责人：")]), _vm._v(_vm._s(_vm.detailData.hrName || '-') + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('b', [_vm._v("加入日期：")]), _vm._v(_vm._s(_vm.detailData.joinDate) + "\n        ")])], 1), _vm._v(" "), _c('Divider', [_vm._v("月度统计数据")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.detailColumns,
      "data": _vm.monthlyStats,
      "size": "small",
      "border": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showDetailModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "400",
      "title": "分配HR负责人"
    },
    model: {
      value: (_vm.showHrModal),
      callback: function($$v) {
        _vm.showHrModal = $$v
      },
      expression: "showHrModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "model": _vm.hrParam
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "HR负责人"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择HR负责人",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.hrParam.hrName),
      callback: function($$v) {
        _vm.$set(_vm.hrParam, "hrName", $$v)
      },
      expression: "hrParam.hrName"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showHrModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingHr
    },
    on: {
      "click": _vm.onUpdateHr
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "480",
      "title": "生成历史汇总"
    },
    model: {
      value: (_vm.showBackfillModal),
      callback: function($$v) {
        _vm.showBackfillModal = $$v
      },
      expression: "showBackfillModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "开始月"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "month",
      "placeholder": "选择开始月",
      "format": "yyyy-MM"
    },
    on: {
      "on-change": _vm.onBackfillStartChange
    },
    model: {
      value: (_vm.backfillParam.startMonth),
      callback: function($$v) {
        _vm.$set(_vm.backfillParam, "startMonth", $$v)
      },
      expression: "backfillParam.startMonth"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "结束月"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "month",
      "placeholder": "选择结束月",
      "format": "yyyy-MM"
    },
    on: {
      "on-change": _vm.onBackfillEndChange
    },
    model: {
      value: (_vm.backfillParam.endMonth),
      callback: function($$v) {
        _vm.$set(_vm.backfillParam, "endMonth", $$v)
      },
      expression: "backfillParam.endMonth"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#999",
      "padding-left": "90px",
      "line-height": "1.5"
    }
  }, [_vm._v("\n        将按起止月幂等写入月汇总表；当月不落表（保持实时）。可用于支撑累计与排行历史。\n      ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showBackfillModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingBackfill
    },
    on: {
      "click": _vm.onGenerateRewardMonth
    }
  }, [_vm._v("生成")])], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/referrer/info/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e4ff8ed","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/ReferrerList.vue
// module id = 1858
// module chunks = 8